(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TabletDialogController', TabletDialogController);

    TabletDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Tablet'];

    function TabletDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Tablet) {
        var vm = this;

        vm.tablet = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tablet.id !== null) {
                Tablet.update(vm.tablet, onSaveSuccess, onSaveError);
            } else {
                Tablet.save(vm.tablet, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:tabletUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
